
import { Component, Mixins } from 'vue-property-decorator';
import OperationComponentMixin from '@/mixins/OperationComponentMixin.vue';

@Component
export default class OperationSub extends Mixins(OperationComponentMixin) {
  get notes(): string | null {
    return this.operationChild?.subNotes || null;
  }

  get hasNotes(): boolean {
    if (this.operationChild && 'subNotes' in this.operationChild === false) return false;
    return this.operationChild?.subNotes !== null;
  }

  get subDefined(): boolean {
    return this.operationChild && 'subDefined' in this.operationChild ? this.operationChild.subDefined : false;
  }

  get subSigned(): boolean {
    return this.operationChild && 'subSigned' in this.operationChild ? this.operationChild.subSigned : false;
  }

  get subSent(): boolean {
    return this.operationChild && 'subSent' in this.operationChild ? this.operationChild.subSent : false;
  }

  get subDescription(): string {
    if (this.subSent) return 'Subappalto inviato';
    if (this.subSigned) return 'Subappalto firmato';
    if (this.subDefined) return 'Subappalto definito';
    return 'Subappalto non definito';
  }

  get columnClass(): string {
    if (this.operationChild?.flatTasks.includes('I=c')) return 'completed';
    if (this.operationChild?.flatTasks.includes('I=e')) return 'error';

    if (this.subSigned) return 'completed';
    if (this.subSent) return 'selected';
    return '';
  }

  onEdit() {
    console.log('OperationInstallation: onEdit()'); // eslint-disable-line no-console
    this.$emit('edit');
  }
}
